export default __webpack_public_path__ + "static/media/algo-traffic-icon.f1224efd.png";